export function isRouteHome(route: string): boolean {
  return /home/i.test(route);
}
export function isRouteApplication(route: string): boolean {
  return route === 'application' || route === '/bank/application';
}
export function isRouteApplications(route: string): boolean {
  return route === 'applications' || route === '/bank/applications';
}
